import VerifyOTP from 'Components/auth/VerifyOTPNew';
import { useFormik } from 'formik';
import useDocumentTitle from 'hooks/useDocumentTitle';
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Form, Button, FormFeedback, Input, Spinner, Alert } from 'reactstrap';
import { generateLoginOTP } from 'services/api/auth';
import { resetAuthFlags, setError } from 'slices/auth/reducer';
import { login } from 'slices/auth/thunk';
import { AppDispatch, RootState } from 'store';
import { getErrorMessage } from 'utils/helpers';
import * as Yup from "yup";


const Login = () => {

    const dispatch: AppDispatch = useDispatch();

    useDocumentTitle("Sign In");

    const navigate = useNavigate();

    const error = useSelector((state: RootState) => state.auth.error);

    const [loader, setLoader] = useState<boolean>(false);

    const [otpSent, setOTPSent] = useState<boolean>(false);

    const [userInfo, setUserInfo] = useState<{ username: string, otp: string }>({ username: '', otp: '' });

    const sendOTP = async (userCredentials: { username: string }) => {
        try {
            dispatch(setError(null));
            setLoader(true);
            const status = await generateLoginOTP(userCredentials);
            if (status) {
                setOTPSent(true)
            }
        } catch (error) {
            console.log(error, getErrorMessage(error, 'Failed to send OTP'))
            dispatch(setError(getErrorMessage(error, 'Failed to send OTP')));
        } finally {
            setLoader(false);
        }
    }

    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email").email("Please enter a valid Email Address"),
        }),
        onSubmit: async (values) => {
            setUserInfo({ username: values.email, otp: '' });
            await sendOTP({ username: values.email });
        }
    });

    const handleVerification = async (otp: string) => {
        const response = await dispatch(login({ username: userInfo.username, otp }))
        if (response.meta.requestStatus === 'fulfilled') {
            navigate('/');
        }
    }

    useEffect(() => {
        dispatch(resetAuthFlags());
    }, [dispatch])

    return (
        <div className='d-flex vh-100 auth-page'>
            <div className="illustrator-side">
                <div className="illustrator-center-content">
                    <h6>1,00,000+</h6>
                    <h6>influencers</h6>
                </div>
            </div>
            <div className="auth-side">
                <div></div>
                <div className="auth-form">
                    {
                        !otpSent ? (
                            <React.Fragment>
                                <h2 className='auth-title'>Welcome Back</h2>
                                <span className="auth-helper-text">Sign In to continue to influns</span>

                                {error && <Alert className="mt-4" color="danger"> {error} </Alert>}

                                <Form
                                    onSubmit={(e) => {
                                        e.preventDefault();
                                        validation.handleSubmit();
                                        return false;
                                    }}
                                    action="#">

                                    <div className="my-3">
                                        <Input
                                            name="email"
                                            className="form-control auth-input"
                                            placeholder="Enter email"
                                            type="email"
                                            onChange={validation.handleChange}
                                            onBlur={validation.handleBlur}
                                            value={validation.values.email || ""}
                                            invalid={
                                                validation.touched.email && validation.errors.email ? true : false
                                            }
                                        />
                                        {validation.touched.email && validation.errors.email ? (
                                            <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
                                        ) : null}
                                    </div>

                                    <div className="mt-4">
                                        <Button
                                            disabled={loader}
                                            className="theme-btn theme-btn-lg btn-primary w-100" type="submit">
                                            {loader && <Spinner size="sm" className='me-2'> Loading... </Spinner>}
                                            Generate OTP
                                        </Button>
                                    </div>
                                </Form>
                            </React.Fragment>
                        ) : (
                            <VerifyOTP
                                username={userInfo.username}
                                changeEmail={() => setOTPSent(false)}
                                resendOTP={async () => {
                                    return await generateLoginOTP({ username: userInfo.username });
                                }}
                                submitButtonText='Sign In'
                                handleVerification={handleVerification}
                            />
                        )
                    }
                </div>
                <div className="auth-switch">
                    <span className='auth-switch-text'>Don't have an Account? <Link to={{ pathname: '/register' }}>Sign Up</Link></span>
                </div>
            </div>
        </div>
    )
}

export default Login